export { default } from "./app-radio.component";
export * from "./app-radio.component.types";
